/**
 * Tracks the RTK Query `requestId`s of mutation dispatches that originate from
 * the offline replay path (`dispatchQueuedMutation`).
 *
 * The mutation-queue middleware consults this set so that a REPLAY which fails
 * again is NOT re-enqueued as a brand-new item. Without it, a queued mutation
 * that keeps failing with a retriable 5xx re-enters the middleware on every
 * replay, gets a fresh id + `attempts = 0`, and loops forever — the original
 * item is meanwhile removed as a false success, so `attempts` / backoff /
 * dead-letter never engage. Marking the replay dispatch lets `attempts`
 * accumulate on the ORIGINAL queued item via `replayMutationQueue`.
 */
const replayRequestIds = new Set<string>()

export const markReplayRequest = (requestId: string): void => {
  replayRequestIds.add(requestId)
}

export const unmarkReplayRequest = (requestId: string): void => {
  replayRequestIds.delete(requestId)
}

export const isReplayRequest = (requestId: string | undefined): boolean =>
  typeof requestId === 'string' && replayRequestIds.has(requestId)
